import React, { useCallback } from "react"
import { StyleSheet, View } from "react-native"
import { bindActionCreators } from "redux"
import { connect } from "react-redux"

import useClassroomInfo from "../../hooks/useClassroomInfo"
import useAssetBaseUri from "../../hooks/useAssetBaseUri"
import { getReqOptionsWithAdditions } from '../../utils/toolbox'

import AudioPlayer from "./AudioPlayer"

const styles = StyleSheet.create({
  container: {
    paddingVertical: 20,
    paddingHorizontal: 30,
    flex: 1,
  },
})

const AudioTool = React.memo(({
  bookId,
  toolUid,
  classroomQueryString,
  logUsageEvent,

  audioFile={},
  audioLink,

  idps,
  accounts,
  books,
}) => {

  const logUsageEventWithToolUid = useCallback(
    params => {
      logUsageEvent({
        toolUid,
        ...params,
      })
    },
    [ logUsageEvent, toolUid ],
  )

  const { accountId, classroomUid } = useClassroomInfo({ books, bookId })
  const baseUri = useAssetBaseUri({ idps, accounts, forceCookieInUri: !classroomQueryString })

  const uri = audioLink || `${baseUri}/enhanced_assets/${classroomUid}/${audioFile.filename}${classroomQueryString}`

  if(!audioLink && !audioFile.filename) return null

  return (
    <View style={styles.container}>
      <AudioPlayer
        source={{
          ...(audioLink ? {} : getReqOptionsWithAdditions({
            headers: {
              "x-cookie-override": accounts[accountId].cookie,
            },
          })),
          uri,
        }}
        logUsageEvent={logUsageEventWithToolUid}
      />
    </View>
  )
})

const mapStateToProps = ({ idps, accounts, books }) => ({
  idps,
  accounts,
  books,
})

const matchDispatchToProps = (dispatch, x) => bindActionCreators({
}, dispatch)

export default connect(mapStateToProps, matchDispatchToProps)(AudioTool)